import React from "react";
import { sortBy } from "lodash";
import SettingLabel from "./SettingLabel";
import SettingHelpText from "./SettingHelperText";
import Skeleton from "../library/Skeleton";
import RecruiterUser from "../../apiResources/RecruiterUser";

const SectorsSettingOption = (props: Props) => {
  const { user, isLoading } = props;

  const sectors = sortBy(user?.recruiter?.sectors, ["name"]);

  return (
    <section>
      <SettingLabel>Your sectors</SettingLabel>
      <SettingHelpText>
        Please contact your account manager to change these
      </SettingHelpText>
      {isLoading && <Skeleton height="100" />}
      {!isLoading && !sectors.length && (
        <div>There are no sectors attached to your account</div>
      )}
      {sectors.length > 0 && (
        <ul>
          {sectors.map((sector) => (
            <li key={sector.id}>
              <div>{sector.name}</div>
              <ul>
                {sector.subSectors.map((subSector) => (
                  <li key={subSector.id}>{subSector.name}</li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};

type Props = {
  user: RecruiterUser;
  isLoading?: boolean;
};

export default SectorsSettingOption;
